import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'w-checked'
})
export default class Checked extends Vue {
    @Prop({default: 16}) size : number
}
